<template>
  <div class="form-group">
    <label class="col-md-3"><span class="required-label">*</span>{{label}}</label>
    <div class="col-md-6">
      <el-upload
        :action="docEndPointMetaFile"
        name="meta_file"
        :headers="header"
        :on-error="handleError"
        :on-success="handleSuccess"
        :before-upload="beforeUpload"
        :limit="1"
        :on-exceed="handleExceed"
        drag>
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">Drop file here or <em>click to upload</em></div>
        <div class="el-upload__tip" slot="tip"><strong>format file dalam pdf / jpg / png dan tidak boleh lebih dari 1 Mb</strong></div>
      </el-upload>
      <div v-if="val" style="margin-top: 20px" class="alert alert-success">File berhasil disimpan. <a :href="val" target="_blank">Cek Dokumen</a></div>
      <span v-show="error" class="error-label">Upload {{label}}</span>
    </div>
    <input
      v-show="false"
      type="text"
      :name="name"
      :placeholder="label"
      class="form-control"
      v-model="val"
      v-validate="'required'"
    >
  </div>
</template>

<script>
import { baseURL } from '@/api/data'
import api from '@/api'

export default {
  data () {
    return {
      val: null,
      error: false
    }
  },
  mounted () {
    api.get(`/v2/data_khusus/${this.nomorPendaftar}/${this.name}`)
      .then(response => {
        this.val = response.data.data.value
        this.$emit('input-file-change', {name: this.name, value: response.data.data.value})
      })
      .catch(e => {
        this.$emit('input-file-change', {name: this.name, value: null})
      })
    this.$root.$on('input-khusus-validate', this.validate)
  },
  props: ['name', 'label'],
  computed: {
    header () {
      let token = localStorage.getItem('client-admisi-token')
      let headerAPI = {
        'Authorization': `Bearer ${token}`
      }
      return headerAPI
    },
    docEndPointMetaFile () {
      if (process.env.NODE_ENV !== 'test') {
        return baseURL + 'v2/data_khusus/upload'
      } else {
        return 'test'
      }
    },
    nomorPendaftar () {
      return this.$store.getters.getAuthData.data.mhs_jalur.nomor_pendaftar
    }
  },
  methods: {
    beforeUpload (file) {
      const isMIME = file.type === 'application/pdf' || file.type === 'image/png' || file.type === 'image/jpeg'
      const isLt2M = file.size < 1000000
      !isMIME ? alert('Dokumen berformat pdf/jpg/png') : false
      !isLt2M ? alert('Dokumen tidak boleh lebih dari 1 Mb') : false
      return isMIME && isLt2M
    },
    handleError (err, file, fileList) {
      if (process.env.NODE_ENV !== 'test') {
        let res = JSON.parse(err.message)
        alert(`upload error, ${res.message}`)
      } else {
        this.val = 'test'
      }
    },
    handleExceed () {
      alert('maksimal 1 file')
    },
    handleSuccess (res, file) {
      this.val = res.url
      this.$emit('input-file-change', {name: this.name, value: this.val})
      this.validate()
      alert('upload sukses')
    },
    validate () {
      this.val === null ? this.error = true : this.error = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/File.vue